var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ReportEvents, ReportPlayerEvents } from '../../../lib/report/service';
import { stringifyFields } from './utils';
/**
 * @shm/interface need to be installed to use this collector
 */
export class SHMAPICollector {
    receive(events, commonParams) {
        const transformed = events.map((event) => {
            return {
                fields: stringifyFields(event),
            };
        });
        return ReportEvents({
            events: transformed,
            common: commonParams ? stringifyFields(commonParams) : {},
        });
    }
}
/**
 * adapter to data tracker field
 * - user_id -> mid
 * @param params SHMEvent params
 */
function convertToDTParams(params) {
    if (!params) {
        return {};
    }
    const { user_id: mid } = params, rest = __rest(params, ["user_id"]);
    return Object.assign(Object.assign({}, rest), { mid });
}
export class DTAPICollector {
    receive(events, commonParams) {
        const dtCommonParams = convertToDTParams(commonParams);
        const transformed = events.map((event) => JSON.stringify(Object.assign(Object.assign({}, dtCommonParams), event)));
        return ReportPlayerEvents({
            events: transformed,
        });
    }
}
